<template>
    <div class="page-error">
        <div class="text-center">
            <img src="../../assets/img/web-error.png" width="558px">
            <p class="f-16 m-t-30">您访问的页面不存在</p>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {

        }
    },
    created(){

    },
    methods: {

    }
}
</script>
<style scoped>
.page-error{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);margin-left: 100px}
</style>

